
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[[...params]]",
      function () {
        return require("private-next-pages/forum/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/[[...params]]"])
      });
    }
  